var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsmode = function SvgNewsmode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "M1.59 15.083q-.632 0-1.07-.437a1.45 1.45 0 0 1-.437-1.07V2.424q0-.63.438-1.069A1.45 1.45 0 0 1 1.59.917h12.82q.631 0 1.069.437.438.438.438 1.07v11.153q0 .63-.438 1.069a1.45 1.45 0 0 1-1.069.437zm0-1.25h12.82a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.176V2.423a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08H1.59a.25.25 0 0 0-.177.08.25.25 0 0 0-.08.176v11.154q0 .096.08.176.081.08.177.08m1.73-1.987h9.36v-1.25H3.32zm0-3.221h3.077V4.154H3.32zm4.904 0h4.455v-1.25H8.224zm0-3.221h4.455v-1.25H8.224z"
  })));
};
export default SvgNewsmode;